import {services} from '../../application/service/services';
import {FeedbackExternalErrorReportDTO} from "../model";

export enum RelaunchStep {
    SOURCING = 'SOURCING',
    PROCESSING = 'PROCESSING',
    INDEXING = 'INDEXING',
    PUSH = 'PUSH',
}

export class SourcingService {
    _sourcingFetcher;
    _progressFetcher;

    init() {
        this._sourcingFetcher = services.getFetcherService().getFetcher('sourcing');
        this._progressFetcher = services.getFetcherService().getFetcher('progress');
    }

    isAuthorized(): boolean {
        return this.isAuthorizedForJson()
            || this.isAuthorizedForFile()
            || this.isAuthorizedForAudio();
    }

    isAuthorizedForJson() {
        return services.getSecurityService().hasRole('vecko.sourcing.push_raw');
    }

    isAuthorizedForFile() {
        return services.getSecurityService().hasRole('vecko.sourcing.push_file');
    }

    isAuthorizedForAudio() {
        return services.getSecurityService().hasRole('vecko.sourcing.push_audio');
    }

    async sourceAudio(data: any): Promise<void> {
        await this._sourcingFetcher.sourcingAudio(data);

        services.getApplicationService().notifyMessage({
            level: 'SUCCESS',
            text: {
                key: 'administration.sourcing.local.source.success'
            }
        });
    }

    async sourceXlsx(file: File): Promise<void> {
        const sourcingResult: Array<FeedbackExternalErrorReportDTO> = await this._sourcingFetcher.sourcingXlsx(file);
        this.displayNotification(sourcingResult);
    }

    async sourceCsv(data: any): Promise<void> {
        const sourcingResult: Array<FeedbackExternalErrorReportDTO> = await this._sourcingFetcher.sourcingCsv(data);
        this.displayNotification(sourcingResult);
    }

    async sourceJson(file: File): Promise<void> {
        const sourcingResult: Array<FeedbackExternalErrorReportDTO> = await this._sourcingFetcher.sourcingJson(file);
        this.displayNotification(sourcingResult);
    }

    private displayNotification(sourcingResult: Array<FeedbackExternalErrorReportDTO>) {
        const nbErrors = sourcingResult.filter(report => report.inError).length;
        if (nbErrors > 0) {
            const tenant = sourcingResult[0].system.tenant;
            const stream = sourcingResult[0].system.stream;
            const errorLink = "/admin/sourcing/feedbackExplorer?tenant=" + tenant + "&stream=" + stream + "&status=SOURCING_REQUESTED_ERROR";
            services.getApplicationService().notifyMessage({
                level: 'ERROR',
                text: {
                    key: 'administration.sourcing.local.source.error',
                    args: {
                        nbErrors: nbErrors,
                        link: errorLink
                    }
                }
            });
        } else {
            services.getApplicationService().notifyMessage({
                level: 'SUCCESS',
                text: {
                    key: 'administration.sourcing.local.source.success'
                }
            });
        }
    }

    async relaunch(tenant: string, stream: string, id: string, step: RelaunchStep) {
        await this._progressFetcher.relaunchProcess(tenant, stream, id, step);
        services.getApplicationService().notifyMessage({
            level: 'SUCCESS',
            text: {
                key: 'administration.sourcing.feedback.relaunch.success'
            }
        });
    }
}

services.registerService('sourcingService', new SourcingService());